import React from "react";

const PopupModalCreate = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div 
        className="absolute inset-0 bg-black/50" 
        onClick={onClose}
      ></div>
      <div className="relative z-10 bg-white rounded-lg max-w-md w-full mx-4 shadow-xl">
        {children}
      </div>
    </div>
  );
};

export default PopupModalCreate;
